/**
 * ION operation types.
 */
enum OperationType {
  Create = 'create',
  Update = 'update',
  Deactivate = 'deactivate',
  Recover = 'recover'
}

export default OperationType;
